import { PayrollProcessingSystemId } from '@xemplo/gp-types';
import { XemploLoader } from '@xemplo/loader';

import { useValidPayrun } from './use-valid-payrun';

/**
 * Interim XemploPay pay run detail view — a plain printout of the pay run while
 * the real experience is built. The flagged route resolves here and reuses the
 * shared guard in useValidPayrun (redirects away when the flag is off or the
 * pay run isn't XemploPay).
 */
export const XemploPayPayrun = () => {
  const { showLoader, data } = useValidPayrun(PayrollProcessingSystemId.XemploPay);

  if (showLoader) {
    return <XemploLoader />;
  }

  const payrun = data?.result;
  const details: [string, string | undefined][] = [
    ['Name', payrun?.name],
    ['ID', payrun?.id],
    ['Company', payrun?.companyName],
    ['Business unit', payrun?.businessUnitName],
    ['Processing system', payrun?.payrollProcessingSystemName],
    ['Status', payrun?.payrunStatusName],
    ['Pay date', payrun?.payDate ? String(payrun.payDate) : undefined],
  ];

  return (
    <dl>
      {details.map(([label, value]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{value ?? '—'}</dd>
        </div>
      ))}
    </dl>
  );
};
